import {
  computed,
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { AuthSelectorsFacade } from '@ps/auth-data-access';

import { UserSettingsSelectorsFacade } from '../state/user-settings.selectors.facade';
import { canAccess, AccessRequirement } from '../utils/role-access.helper';

@Directive({
  selector: '[psCanAccess]',
  standalone: true,
})
export class CanAccessDirective {
  private readonly _auth = inject(AuthSelectorsFacade);
  private readonly _userSettings = inject(UserSettingsSelectorsFacade);
  private readonly _templateRef = inject(TemplateRef<unknown>);
  private readonly _viewContainer = inject(ViewContainerRef);

  public readonly psCanAccess = input<AccessRequirement>({});
  public readonly psCanAccessElse = input<TemplateRef<unknown> | null>(null);

  private readonly _hasAccess = computed((): boolean =>
    canAccess({
      userType: this._auth.userType(),
      userAccessLevel: this._auth.userAccessLevel(),
      config: this.psCanAccess(),
      buyerSettings: this._userSettings.buyerSettings(),
    }),
  );

  constructor() {
    effect((): void => {
      this._viewContainer.clear();

      if (this._hasAccess()) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      } else {
        const elseTemplate = this.psCanAccessElse();
        if (elseTemplate) {
          this._viewContainer.createEmbeddedView(elseTemplate);
        }
      }
    });
  }
}
